import { unsubscribeFromNotifications } from './unsubscribeFromNotifications';

export function rejectPushNotifications() {
    unsubscribeFromNotifications();
    setNotificationsRejected(true);
}
